<!--
  @component DeploymentsHeader — the Deployments feature's sub-header.
  tier:   feature header (owns WHAT is in the header; the shell owns WHERE,
          and <SubNav> owns the shared look).

  Layout: the project-scope selector lives in the SubNav `lead` slot (left);
  the section tabs (Overview · Releases · Code · Domain · Data · Performance ·
  Logs) follow. Tabs are section-scoped and always live — they navigate to
  `/deployments/<section>` and the current scope (held by ScopeIO) decides what
  that section renders. "Which projects" is the scope selector's job, not a tab.
-->
<script lang="ts">
  import SubNav from "../../../../global/visuals/primitives/SubNav.svelte";
  import type { FeatureHeaderProps } from "../../../../global/visuals/primitives/feature-header.js";
  import { DEPLOYMENT_TABS } from "./deployment-tabs.js";
  import { useScopeIO, scopeToParam } from "./ScopeIO.svelte";
  import ScopeSelector from "./ScopeSelector.svelte";

  const { activeScreen, onNavigate }: FeatureHeaderProps = $props();
  const scope = useScopeIO();

  // Switching section preserves the current scope (?p=).
  function select(id: string): void {
    onNavigate(`/deployments/${id}?p=${scopeToParam(scope.scope)}`);
  }
</script>

<SubNav
  items={DEPLOYMENT_TABS}
  activeId={activeScreen}
  onSelect={select}
  ariaLabel="Deployments sections"
>
  {#snippet lead()}
    <ScopeSelector />
  {/snippet}
</SubNav>
